import { AsyncState, Updater, loadingAsyncState } from 'widgets-for-react'
import { getMailPlusForm, MailPlusFormState } from '../mailPlusForm/mailPlusFormState'
import { footerApi } from './footerApi'

export type FooterState = {
  footerDataState: AsyncState<FooterData>,
  mailPlusForm: MailPlusFormState
}

export type FooterData = {
  Column: number,
  Items: FooterItem[]
}[]

export interface FooterItem {
  Title: string,
  Order: number,
  Link: {
    Title: string,
    Url: string
  }
}

export const initialFooterState: (formId: string) => FooterState = (formId) => ({
  footerDataState: loadingAsyncState(footerApi),
  mailPlusForm: {
    formId,
    result: loadingAsyncState(() => getMailPlusForm(formId))
  }
})

export const footerStateUpdaters = {
  updateFooterDataState:
    (updater: Updater<AsyncState<FooterData>>) =>
    (currentState: FooterState): FooterState => ({
      ...currentState,
      footerDataState: updater(currentState.footerDataState),
    }),
}
